import type { User, UserOrganization } from '@server/types/responseTypes'
import { create } from 'zustand'

export interface AuthState {
  isLoadingExternalAuth: boolean
  hasExternalAuth: boolean
  isLoading: boolean
  user?: User
  organizations?: UserOrganization[]
  error?: unknown

  signIn: () => void
  signOut: (options?: { redirectUrl?: string }) => void
  accessTokenGetter: () => Promise<string | null>
  getAccessToken: () => Promise<string | null>
  // internal setter (for your hook to push updates)
  setAuthState: (
    partial: Partial<Omit<AuthState, 'setAuthState' | 'getAccessToken'>>,
  ) => void
}

export const useAuthStore = create<AuthState>((set, get) => ({
  isLoadingExternalAuth: false,
  hasExternalAuth: false,
  isLoading: false,
  user: undefined,
  organizations: undefined,
  error: undefined,
  authStatus: 'INITIAL_LOADING',
  // these will be overwritten by your hook
  signIn: () => undefined,
  signOut: () => undefined,
  accessTokenGetter: async () => null,

  getAccessToken: async () => {
    try {
      const token = await get().accessTokenGetter()
      return token
    } catch (error) {
      console.error(error)
      return null
    }
  },

  // helper to merge in new state
  setAuthState: (partial) => set(partial),
}))
